import { useState } from "react";
import { cashnator, decashnator, isNumeric } from "../../../../utils/functions";
import { gradingTypes, gradingTypeSupportsAutograph, normalizeGradingType, preLacreFormatLabels, priorityTypes } from "../../../../utils/gradingTypes";
import Button from "../../../../atoms/button";


const PartnerProductStep = ({ setStep, setProductData, productData }) => {

    const [gradingType, setGradingType] = useState(productData?.gradingType || "premium");
    const [numberOfCards, setNumberOfCards] = useState(productData?.numberOfCards || "");
    const [priority, setPriority] = useState(productData?.priority || "low");
    const [declaredValue, setDeclaredValue] = useState(cashnator(productData?.declaredValue) || "R$0,00");
    const [autographEvaluation, setAutographEvaluation] = useState(!!productData?.autographEvaluation);
    const [preLacreFormat, setPreLacreFormat] = useState(productData?.preLacreFormat || "with_subgrades");

    const handleNumberOfCards = (value) => {
        if (!isNumeric(value)) {
            return null;
        }
        let numberValue = parseInt(value);
        setNumberOfCards(value);
        if (numberValue > 1200) {
            setNumberOfCards(1200);
            numberValue = 1200;
        }
        if (numberValue > 84 && ["none"].includes(priority)) {
            setPriority("low");
        }
        if (numberValue > 126 && ["none", "low"].includes(priority)) {
            setPriority("mid");
        }
        if (numberValue > 252 && ["none", "low", "mid"].includes(priority)) {
            setPriority("high");
        }
        if (numberValue > 504 && ["none", "low", "mid", "high"].includes(priority)) {
            setPriority("max");
        }
        if (numberValue > 1200 && ["none", "low", "mid", "high", "max"].includes(priority)) {
            setPriority("");
        }
    }

    const handleDeclaredValue = (value) => {
        if (!value) {
            setDeclaredValue("");
            return null;
        }
        const newValue = decashnator(value);
        if (isNumeric(newValue)) {
            setDeclaredValue(cashnator(newValue));
        }
    }

    const handleNext = () => {
        if (disableNext) {
            return null;
        }
        setProductData({
            gradingType,
            numberOfCards,
            priority,
            declaredValue: decashnator(declaredValue),
            autographEvaluation: gradingTypeSupportsAutograph(gradingType) && autographEvaluation,
            ...(normalizeGradingType(gradingType) === "pre" ? { preLacreFormat } : {})
        });
        setStep(2);
        return null;
    }

    const goBack = () => {
        setStep(0);
    }

    const disableNext = gradingType === "" || (!numberOfCards || numberOfCards === "0") || !priority || decashnator(declaredValue) < 100;

    return (
        <div className="relative">
            <h2 className="text-lg border-t border-b border-primary py-2 mb-4">Dados do pedido</h2>

            <div className="">
                <div className="flex gap-2 justify-center px-4 mb-2">
                    <label className="flex-1">Tipo:</label>
                    <select value={gradingType} onChange={e => {
                        const next = e.target.value;
                        setGradingType(next);
                        if (!gradingTypeSupportsAutograph(next)) {
                            setAutographEvaluation(false);
                        }
                    }} className="flex-1 text-black text-center">
                        {
                            Object.keys(gradingTypes).map((g, i) => (
                                <option key={i} value={g}>
                                    {gradingTypes[g]}
                                </option>
                            ))
                        }
                    </select>
                </div>
                <div className="flex gap-2 justify-center px-4 mb-2">
                    <label className="flex-1">Número de cartas:</label>
                    <input className="flex-1 text-center text-black" type="text" value={numberOfCards} onChange={e => handleNumberOfCards(e.target.value)} />
                </div>
                {gradingTypeSupportsAutograph(gradingType) ? (
                    <div className="flex gap-2 justify-center px-4 mb-2">
                        <label className="flex-1">Avaliação de autógrafo:</label>
                        <input type="checkbox" checked={autographEvaluation} onChange={e => setAutographEvaluation(e.target.checked)} className="accent-[#D4A017]" />
                    </div>
                ) : null}
                {
                    normalizeGradingType(gradingType) === "pre" ?
                        <div className="flex gap-2 justify-center px-4 mb-2">
                            <label className="flex-1">Pré lacre:</label>
                            <select value={preLacreFormat} onChange={e => setPreLacreFormat(e.target.value)} className="flex-1 text-black text-center">
                                {
                                    Object.keys(preLacreFormatLabels).map((k, i) => (
                                        <option key={i} value={k}>{preLacreFormatLabels[k]}</option>
                                    ))
                                }
                            </select>
                        </div>
                        : null
                }
                <div className="flex gap-2 justify-center px-4 mb-2">
                    <label className="flex-1">Prioridade:</label>
                    <select value={priority} onChange={e => setPriority(e.target.value)} className="flex-1 text-black text-center">
                        {
                            Object.keys(priorityTypes).map((p, i) => (
                                <option key={i} value={p}>
                                    {priorityTypes[p]}
                                </option>
                            ))
                        }
                    </select>
                </div>
                <div className="flex gap-2 justify-center px-4 mb-2">
                    <label className="flex-1">Valor declarado:</label>
                    <input className="flex-1 text-center text-black" type="text" value={declaredValue} onChange={e => handleDeclaredValue(e.target.value)} />
                </div>
            </div>

            <div className="flex gap-4 w-fit m-auto">
                <Button click={goBack} classes="bg-purple-400 hover:bg-purple-300 mt-4">Voltar</Button>
                <Button click={handleNext} classes="bg-green-400 hover:bg-green-300 mt-4" disabled={disableNext}>Avançar</Button>
            </div>
        </div>
    )
}

export default PartnerProductStep;
